<template>
  <div>
    <div v-if="this.progress != null">
      <h5 style="line-height:0.1; margin-top: 18px; margin-bottom: -10px; font-size: 15px;" :class="progress_color_text">{{ progress }} %</h5>
      <vs-progress :percent="progress" :color="progress_color">primary</vs-progress>
    </div>
    <div v-else>
      <!-- <h5 style="line-height:1.2; margin-top: 15px;">N/A</h5> -->
      
      <vs-avatar text="N/A" style="margin-top: 10px;"/>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: "CapacityDeviceAgGridComponent",
    data() {
      return {
        statusColor: '',
        statusText: '',
        statusIcon: '',
        progress: null,
        progress_color: 'success',
        progress_color_text: 'text-success',
        progress_info: ''
      }
    },
    mounted() {
      if (this.params.data.system_info.hasOwnProperty('used_disk') && this.params.data.system_info.hasOwnProperty('total_disk')) {
       
          let used_disk = parseFloat(this.params.data.system_info.used_disk)
          let total_disk = parseFloat(this.params.data.system_info.total_disk)
          let result = 0
          if (used_disk >= 0 && total_disk > 0) {
            result = (used_disk/total_disk) * 100
          }
          this.progress = parseFloat(result.toFixed(2))
          if (this.progress > 85) {
            this.progress_color = 'danger'
            this.progress_color_text = 'text-danger'
          } else if (this.progress>=70 && this.progress <= 85 ) {
            this.progress_color = 'warning'
            this.progress_color_text = 'text-warning'
          } else {
            this.progress_color = 'success'
            this.progress_color_text = 'text-success'
          }
        } else {
          this.progress = null
        }
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 10%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .line-0 {
    line-height: 0;
  }
</style>